module.exports = __webpack_public_path__ + "img/205_206.84a68d10.png";